// Internet Explorer 6-11
export const isIE = /* @cc_on!@ */false || !!document.documentMode;

// Edge 20+
export const isEdge = !isIE && !!window.StyleMedia;
